export const formatParticipantExclusionToast = (result = {}, { name } = {}) => {
  const removed = result.removed ?? 0
  if (removed === 1 && name) {
    return `${name} removed from the campaign.`
  }
  if (removed === 1) {
    return '1 participant removed from the campaign.'
  }
  if (removed > 1) {
    return `${removed} participants removed from the campaign.`
  }
  return 'No participants were removed.'
}
